import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** 報價單 detail（lines[] 依畫面順序；`record.updatedAt` 為下次寫入的版本）。 */
export async function fetchQuotationDetail(id) {
  const { data: raw } = await request.get(`/crm/quotations/${id}`);
  return parseVer4DetailResponse(raw);
}
